<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">View Car Park Claim</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <div class="row">
            <div class="col-md-12">
                <!-- Form -->
                <div class="row align-items-center">
                    <div class="col-md-2">Company</div>
                    <div class="col-md-4 pl-md-0">
                        <select class="custom-select" v-model="company">
                            <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                                {{ item.CompanyName }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row align-items-center mt-2">
                    <div class="col-md-2">Employee Name/ID</div>
                    <div class="col-md-4 pl-md-0">
                        <Select2 v-model="userId" :options="employees" v-if="role == 'admin'" />
                        <span v-else>{{ employees.length ? employees[1].text : "" }}</span>
                    </div>
                    <div class="col-md-2 ml-md-4">Status</div>
                    <div class="col-md-3 pl-md-0">
                        <select class="custom-select" v-model="status">
                            <option value="">ALL</option>
                            <option value="DRAFT">DRAFT</option>
                            <option value="PENDING">PENDING</option>
                            <option value="APPROVED">APPROVED</option>
                            <option value="REJECTED">REJECTED</option>
                        </select>
                    </div>
                </div>

                <div class="row align-items-center mt-2">
                    <div class="col-md-2">Month</div>
                    <div class="col-md-2 pl-md-0">
                        <select class="custom-select" v-model="month">
                            <option value="">All</option>
                            <option v-for="month in months" :key="month.value" :value="month.value">
                                {{ month.text }}
                            </option>
                        </select>
                    </div>

                    <div class="col-md-2"></div>

                    <div class="col-md-2 ml-md-4">Year</div>
                    <div class="col-md-2 pl-md-0">
                        <select class="custom-select" v-model="year">
                            <option v-for="year in years" :key="year" :value="year">
                                {{ year }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row align-items-center mt-3">
                    <div class="col-md-12 text-center">
                        <button type="button" class="btn btn-primary" @click="search">Search</button>
                    </div>
                </div>
                <!-- /Form -->

                <!-- Pagination -->
                <div class="row">
                    <div class="col-md-6">
                        Show
                        <select class="custom-select" v-model="paging.SizePerPage" style="width: 5em">
                            <option v-for="item in paging.Sizes" v-bind:key="item" v-bind:value="item">
                                {{ item }}
                            </option>
                        </select>
                        entries
                    </div>
                </div>
                <!-- /Pagination -->

                <!-- Table List -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                            <table class="table table-bordered custom-table mb-0">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center" style="width: 5%">
                                            Action
                                        </th>
                                        <th style="width:5%">Year</th>
                                        <th style="width:5%">Month</th>
                                        <th style="width:10%">Status</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in carparkClaims" :key="item.Id">
                                        <td class="text-center">
                                            <router-link class="btn" title="View" :to="{
                                                name: 'carparkClaimFormView',
                                                params: { id: item.Id },
                                            }">
                                                <i class="fa fa-file-text-o"></i>
                                            </router-link>
                                        </td>
                                        <td>{{ item.Year }}</td>
                                        <td>{{ item.Month }}</td>
                                        <td>{{ item.Status }}</td>
                                        <td>{{ item.Remarks }}</td>
                                    </tr>
                                    <tr v-if="carparkClaims && !carparkClaims.length">
                                        <td :colspan="5" class="text-center">
                                            {{ this.noRecordText }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- /Table List -->

                <!--Pagination -->
                <div class="row mb-4" v-if="carparkClaims && carparkClaims.length">
                    <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
                        Showing
                        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
                        to
                        {{
                                paging.CurrentPage * paging.SizePerPage -
                                paging.SizePerPage +
                                carparkClaims.length
                        }}
                        of {{ totalRecords }} entries
                    </div>

                    <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
                        <div class="navbar justify-content-end">
                            <button v-on:click="first()" v-if="paging.CurrentPage != 1" class="btn btn-white">
                                First
                            </button>
                            <button v-on:click="prev()" class="btn btn-white ml-1 mr-3" v-if="paging.CurrentPage > 1">
                                Prev
                            </button>
                            Page
                            <input class="form-control form-control-sm mx-1" type="number" step="1" min="1"
                                :max="paging.TotalPage" v-model="paging.CurrentPage"
                                @change="onCurrentPageChange($event)" style="width: 4rem" />

                            <span>of {{ paging.TotalPage }}</span>
                            <button v-on:click="next()" class="btn btn-white ml-3 mr-1"
                                v-if="paging.CurrentPage < paging.TotalPage">
                                Next
                            </button>
                            <button v-on:click="last()" v-if="paging.CurrentPage != paging.TotalPage"
                                class="btn btn-white">
                                Last
                            </button>
                        </div>
                    </div>
                </div>
                <!--/Pagination -->
            </div>
        </div>
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
    data() {
        return {
            //form
            companies: [],
            company: config.DEFAULT_COMPANY,
            employees: [],
            userId: "00000000-0000-0000-0000-000000000000",
            status: "",
            months: [],
            month: "",
            years: [],
            year: "",
            carparkClaims: [],
            noRecordText: config.NO_RECORD_TEXT,
            //paging
            paging: {
                Search: "",
                CurrentPage: 1,
                TotalPage: "",
                SizePerPage: 100,
                Sizes: [5, 10, 20, 100],
                SortBy: "",
            },
            totalRecords: "",
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
         tokenObj() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        isManager() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.IsManager ? data.IsManager : false;
        }
    },

    watch: {
        "paging.SizePerPage": function (val, oldVal) {
            this.paging.CurrentPage = 1;
            this.getCarparkClaims();
        },
        "paging.CurrentPage": function (val, oldVal) {
            if (val > this.paging.TotalPage) {
                this.paging.CurrentPage = this.paging.TotalPage;
            }
        },
        company(val) {
            this.getEmployees();
        }
    },

    methods: {
        //filter
        getManagerEmployees() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            let param = { Token: this.token, IsActive: true, ManagerID: data.EmployeeID, Company: this.company };
            this.$store.state.isLoading = true;
            API.getManagerEmployees(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        response.data.record.unshift({ department: "", id: "00000000-0000-0000-0000-000000000000", text: "All" });
                        this.employees = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getCompanies() {
            let param = {
                Token: this.token
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getManagerEmployeeCompanies() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            let param = {
                Token: this.token,
                ManagerID: data.EmployeeID
            };
            this.$store.state.isLoading = true;
            API.getManagerEmployeeCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getEmployees() {
            let param = { Token: this.token, Company: this.company };
            this.$store.state.isLoading = true;
            API.getEmployees(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        response.data.record.unshift({ department: "", id: "00000000-0000-0000-0000-000000000000", text: "All", Company: "" });
                        this.employees = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getMonths() {
            this.months = [];
            this.month = "";
            this.months.push({ text: "Jan", value: 1 });
            this.months.push({ text: "Feb", value: 2 });
            this.months.push({ text: "Mar", value: 3 });
            this.months.push({ text: "Apr", value: 4 });
            this.months.push({ text: "May", value: 5 });
            this.months.push({ text: "Jun", value: 6 });
            this.months.push({ text: "Jul", value: 7 });
            this.months.push({ text: "Aug", value: 8 });
            this.months.push({ text: "Sep", value: 9 });
            this.months.push({ text: "Oct", value: 10 });
            this.months.push({ text: "Nov", value: 11 });
            this.months.push({ text: "Dec", value: 12 });
        },
        getYears() {
            let date = new Date();
            let minYear = date.getFullYear() - 5;
            this.years = [];
            for (let year = date.getFullYear(); year > minYear; year--) {
                this.years.push(year);
            }
            this.year = this.years[0];
        },
        //action button
        search() {
            this.getCarparkClaims();
        },
        //table
        getCarparkClaims() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            let userId = data.Id;
            let param = {
                Token: this.token,
                Search: this.paging.Search,
                CurrentPage: this.paging.CurrentPage,
                TotalPage: this.paging.TotalPage,
                SizePerPage: this.paging.SizePerPage,
                SortBy: this.paging.SortBy,
                Company: this.company,
                UserId: this.role == "admin" ? this.userId : userId,
                Status: this.status,
                Month: this.month,
                Year: this.year
            }
            this.$store.state.isLoading = true;
            API.getCarparkClaims(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.carparkClaims = response.data.record;
                        this.totalRecords = response.data.total;
                        this.paging.TotalPage = response.data.pageCount;
                        if (this.paging.CurrentPage > this.paging.TotalPage) {
                            this.paging.CurrentPage = 1;
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //pagination method
        onCurrentPageChange(event) {
            let currentPage = event.target.value;
            if (currentPage < 1) {
                currentPage = 1;
            }
            this.paging.CurrentPage = parseInt(currentPage);
            this.getCarparkClaims();
        },
        first() {
            this.paging.CurrentPage = 1;
            this.getCarparkClaims();
        },
        prev() {
            this.paging.CurrentPage -= 1;
            this.getCarparkClaims();
        },
        next() {
            this.paging.CurrentPage += 1;
            this.getCarparkClaims();
        },
        last() {
            this.paging.CurrentPage = this.paging.TotalPage;
            this.getCarparkClaims();
        },
    },

    created() {
        // if (this.role == "admin") this.getCompanies(); else this.getManagerEmployeeCompanies();
        this.getCompanies();
        this.getEmployees();
        this.getMonths();
        this.getYears();
        this.getCarparkClaims();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Carpark/ViewCarParkClaim.vue